import ReactGA from "react-ga";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function usePageViews() {
    let location = useLocation();
    ReactGA.initialize("UA-120972226-1");

    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [location]);
}
